import { Component, Inject, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export type DialogDataWithTemplate = {
  header: string;
  form?: FormGroup;
  yesText: string;
  noText: string;
  isAffirmativeWarnColor: boolean; //warn-flat
  /** ignored if isAffirmativeWarnColor is true */
  isAffirmativeBasicColor: boolean; //basic stroked
  isAffirmativeBasic: boolean;
  template: TemplateRef<any>;
  extraButtons: TemplateRef<any>;
  hideButtonBar: boolean;
  onOkay: () => Promise<boolean>; //a function that is called when clicking okay. If returns true, closes modal
};

@Component({
  selector: 'dialog-lib',
  templateUrl: 'dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  //default is color 'primary' variant 'flat'
  primaryColor: 'warn' | 'primary' | 'basic' = 'primary';
  primaryButtonVariant: 'basic' | 'raised' | 'flat' | 'stroked' = 'flat';

  constructor(
    public dialogRef: MatDialogRef<DialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogDataWithTemplate
  ) {
    if (data.isAffirmativeWarnColor) {
      this.primaryColor = 'warn';
    } else if (data.isAffirmativeBasicColor) {
      this.primaryColor = 'basic';
      this.primaryButtonVariant = 'stroked';
    } else if (data.isAffirmativeBasic) {
      this.primaryColor = 'basic';
      this.primaryButtonVariant = 'basic';
    }
  }

  clickClose = async (isSave: boolean): Promise<boolean> => {
    if (isSave === true) {
      if (this.data.form?.invalid) {
        this.data.form.markAllAsTouched();
        return false;
      }
      if (this.data.onOkay) {
        const isSuccess = await this.data.onOkay();
        if (isSuccess) {
          this.dialogRef.close(isSave);
        }
        return isSuccess;
      }
    }

    this.dialogRef.close(isSave);
    return true;
  };
}
